// src/pages/ReviewAcknowledgePage.tsx
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Alert, Box } from '@mui/material';
import ReviewActionForm from '../components/Actions/ReviewActionForm';
import { useAuth } from '../contexts/AuthContext';
import { shouldNavigateIntoPortfolioAfterAction } from '../utils/actionFormNavigation';

export default function ReviewAcknowledgePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const token = searchParams.get('token');
  const actionIdParam = searchParams.get('actionId');
  const projectIdParam = searchParams.get('projectId');
  const actionId = actionIdParam ? parseInt(actionIdParam, 10) : null;
  const projectId = projectIdParam ? parseInt(projectIdParam, 10) : null;

  const handleSuccess = () => {
    if (!shouldNavigateIntoPortfolioAfterAction(user)) return;
    setTimeout(() => {
      if (projectId) {
        navigate(`/execution?projectId=${projectId}`);
      } else {
        navigate('/builder');
      }
    }, 2000);
  };

  const handleError = (error: string) => {
    // Error is already displayed in the form component
    console.error('Review acknowledgment error:', error);
  };

  // Allow access without token if actionId is provided (for logged-in users opening from execution view)
  if (!token && !actionId) {
    return (
      <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
        <Alert severity="error" sx={{ maxWidth: 600 }}>
          Invalid link. Token or actionId is missing. Please check your review link and try again.
        </Alert>
      </Box>
    );
  }

  return (
    <Box className="review-acknowledge-page">
      <ReviewActionForm 
        token={token || null}
        actionId={actionId}
        projectId={projectId}
        onSuccess={shouldNavigateIntoPortfolioAfterAction(user) ? handleSuccess : undefined}
        onError={handleError}
      />
    </Box>
  );
}

